import {useLocation, Navigate} from 'react-router-dom'
import {useAuth} from '../modules/auth'

export const RequireMenuAccess = ({ children }) => {
  const { allowedUrls } = useAuth()
  const { pathname } = useLocation()

  if (pathname.startsWith('/apps/call/recording/outbound/detail/')) {
    return children
  }

  const isAllowed = allowedUrls.some(
    (url) => pathname === url || pathname.startsWith(url + '/')
  )

  if (!isAllowed) {
    return <Navigate to='/error/403' replace />
  }

  return children
}
